module.exports = __webpack_public_path__ + "img/unit2.4742a1ab.jpg";